import { render, staticRenderFns } from "./ProductBrandFormModal.vue?vue&type=template&id=b05cd1f8&scoped=true&"
import script from "./ProductBrandFormModal.vue?vue&type=script&lang=js&"
export * from "./ProductBrandFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05cd1f8",
  null
  
)

export default component.exports